// This file contains helper functions for role management

import { Roles } from 'src/pages/auth/constants/AuthConstants';

const internalTeamLeadRoles = {
  [Roles.ROLE_TEAM_LEAD]: Roles.ROLE_TEAM_LEAD,
  [Roles.ROLE_SENIOR_TEAM_LEAD]: Roles.ROLE_SENIOR_TEAM_LEAD,
  [Roles.ROLE_COLLECTION_HEAD]: Roles.ROLE_COLLECTION_HEAD
};

const fieldTLAndClusterAndZonalManagers = {
  [Roles.NAVI_INHOUSE_FIELD_ZONAL_MANAGER]: Roles.NAVI_INHOUSE_FIELD_ZONAL_MANAGER,
  [Roles.NAVI_INHOUSE_FIELD_CLUSTER_MANAGER]: Roles.NAVI_INHOUSE_FIELD_CLUSTER_MANAGER,
  [Roles.ROLE_NAVI_FIELD_TEAM_LEAD]: Roles.ROLE_NAVI_FIELD_TEAM_LEAD
};

const rolesForHidePauseCasesTabCases = {
  [Roles.ROLE_COLLECTION_EFFORTS_PAUSE_ACCESS]: Roles.ROLE_COLLECTION_EFFORTS_PAUSE_ACCESS,
  [Roles.ROLE_GLOBAL_ACCESS]: Roles.ROLE_GLOBAL_ACCESS,
  [Roles.ROLE_COLLECTION_HEAD]: Roles.ROLE_COLLECTION_HEAD,
  [Roles.ROLE_USER_MANAGEMENT_ADMIN]: Roles.ROLE_USER_MANAGEMENT_ADMIN
};

// Check if the user is a team lead
// criteria: user has role  USER_ROLE_TEAM_LEAD, USER_ROLE_INTERNAL_TEAM_LEAD and isNaviUser true
export const isInternalTeamLead = (roles: Array<string>, isNaviUser: boolean): boolean => {
  if (!isNaviUser) return false;
  if (!roles.length) return false;
  let isInternalTeamLead = false;
  for (let i = 0; i < roles.length; i++) {
    if (internalTeamLeadRoles[roles[i] as keyof typeof internalTeamLeadRoles]) {
      isInternalTeamLead = true;
    }
  }
  return isInternalTeamLead;
};

export const checkFieldTLAndClusterAndZonalManagers = (
  roles: Array<string>,
  isNaviUser: boolean
): boolean => {
  if (!isNaviUser) return false;
  if (!roles.length) return false;
  let isInternalTeamLead = false;
  for (let i = 0; i < roles.length; i++) {
    if (
      fieldTLAndClusterAndZonalManagers[roles[i] as keyof typeof fieldTLAndClusterAndZonalManagers]
    ) {
      isInternalTeamLead = true;
    }
  }
  return isInternalTeamLead;
};

export const notHideTabsInCaseOfSnooze = (roles: Array<string>, isNaviUser: boolean): boolean => {
  if (!roles.length) return false;
  let notHideTabsInCaseOfSnooze = false;
  for (let i = 0; i < roles.length; i++) {
    if (rolesForHidePauseCasesTabCases[roles[i] as keyof typeof rolesForHidePauseCasesTabCases]) {
      notHideTabsInCaseOfSnooze = true;
    }
  }
  return notHideTabsInCaseOfSnooze;
};
